import React from 'react'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import cx from 'clsx'
import { useTranslation } from 'react-i18next'

import { useHasPermission } from '@helpers/hooks/useHasPermission'
import { Perm } from '@type/permissions'
import routes from '@src/Routes/routes'

import styles from '../../index.module.css'

const TabNavigation = () => {
  const { id } = useParams()
  const { t } = useTranslation('accounting', { keyPrefix: 'costCenter' })
  // Breakdown tab shows the spend breakdown — gate it on the cost
  // center view perm so finance roles without admin still see it.
  const canViewBreakdown = useHasPermission(Perm.COST_CENTER_VIEW)
  return (
    <div className="flex gap-3">
      <NavLink
        className={({ isActive }) => cx(styles.tab, isActive && styles.active)}
        to={generatePath(routes.private.costCenterBudget, { id })}
      >
        {t('budgetTab.title')}
      </NavLink>
      {canViewBreakdown && (
        <NavLink
          className={({ isActive }) => cx(styles.tab, isActive && styles.active)}
          to={generatePath(routes.private.costCenterBreakdown, { id })}
        >
          {t('breakdownTab.title')}
        </NavLink>
      )}
    </div>
  )
}
export default TabNavigation
